<script>
import VSelect from "vue-select"

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      addButtonDisabled: true,
      selectedUser: null,
      applicantsData: [],
    }
  },
  created() {
    this.getAllApplicants()
  },
  props: ["showAddContactPopup"],
  watch: {
    showAddContactPopup(newVal, oldVal) {
      this.getAllApplicants()
    },
    selectedUser(newVal, oldVal) {

      if (newVal && newVal !== null) {
        this.addButtonDisabled = false
      } else {
        this.addButtonDisabled = true
      }
    },
  },
  methods: {
    async getAllApplicants() {
      try {
        const getAllApplicantsRes = await this.$http.get(
          "/api/chats/applicants"
        )

        this.applicantsData = getAllApplicantsRes.data.data
      } catch (error) {
        this.$toastDanger(
          "Fetching Applicants Data Failed",
          "Please check your internet and try again!"
        )
      }
    },
  },
}
</script>

<template>
  <div
    class="d-flex justify-content-center align-items-center w-100 add-new-contact-dialog"
  >
    <div class="bg-white rounded-lg p-3 w-50 shadow">
      <h3>Add Contact</h3>
      <form>
        <div class="input-group mt-2 no-shadow">
          <div class="container">
            <v-select
              v-model="selectedUser"
              placeholder="Select Applicant"
              :options="applicantsData"
              :reduce="(user) => user.id"
              :filter-by="
                (option, label, search) => {
                  const text =
                    `${option.fullname} ${option.phone_number}`.toLowerCase()
                  return text.includes(search.toLowerCase())
                }
              "
            >
              <template v-slot:option="option">
                <div>{{ option.fullname }} - {{ option.phone_number }}</div>
              </template>

              <!-- Selected value shown inside input -->
              <template v-slot:selected-option="{ fullname, phone_number }">
                <div>{{ fullname }} - {{ phone_number }}</div>
              </template>
            </v-select>
          </div>
        </div>
        <div class="d-flex justify-content-between w-100 mt-4">
          <button
            @click="$emit('on-cancel-click')"
            type="button"
            class="btn btn-danger"
          >
            Cancel
          </button>
          <button
            @click.prevent="$emit('on-add-contact-click', [selectedUser])"
            type="submit"
            class="btn btn-primary"
            :disabled="addButtonDisabled"
          >
            Add
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style>
.add-new-contact-dialog {
  position: absolute;
  z-index: 1000;
  height: 85%;
}
</style>
